export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_users(state, {users}) {
    state.users = users.data;
    state.totalCount = users.total;
    state.count = users.per_page;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
